<template>
  <van-popup
    :lazy-render="true"
    :overlay="true"
    :position="'right'"
    @click-overlay="overlay"
    class="reg_care_pop"
    v-model="show"
  >
    <div class="reg_care">
      <van-checkbox-group
        :max="5"
        class="care_checkbox"
        v-model="typeValse"
      >
        <van-collapse
          :key="index"
          v-for="(item,index) in typeOption"
          v-model="activeName"
        >
          <van-collapse-item
            :name="item.id"
            :title="item.name"
            class="care_item"
          >
            <div class="checkbox_wrap">
              <van-checkbox
                :key="ind"
                :name="mode.id"
                v-for="(mode,ind) in item.lists"
              >{{mode.name}}</van-checkbox>
            </div>
          </van-collapse-item>
        </van-collapse>
      </van-checkbox-group>
    </div>
    <!--    <van-button class="sumbit_btn" color="#f85b0f" block type="info" @click="submit()">确定</van-button>-->
  </van-popup>
</template>
<script>
import categoryData from '@/assets/js/category.json';     //类别json
export default {
  name: "reg-care",
  data () {
    return {
      show: false,
      activeName: [],
      typeOption: [],
      typeValse: [],
      data1: '',
      data2: '',
      newlist: []
    };
  },
  props: ['list'],
  created () {
    this.typeOption = this.getList(categoryData);
    this.activeName.push(categoryData[0].id);
  },
  methods: {
    overlay () {
      // console.log(this.list,'4')
      // this.typeValse = this.list
      //
      // this.edTypevalues()
      // console.log(this.typeValse,'5')
      // this.$emit('careCheck',this.typeValse,this.newlist)
      this.submit()

    },
    open () {
      this.show = true;
      console.log(this.list)
      console.log(this.typeValse, '1')
      this.typeValse = this.list
      this.typeValse = Array.from(new Set(this.typeValse)) //去除重复的数据
      console.log(this.typeValse, '新的选中的感兴趣数组')

    },
    //获取数组  传一个数组json 遍历其下 id 于 name isLists 是否获取其list
    getList (arrJson, isLists = true) {
      let classArr = [];
      console.log(arrJson, 'arrJson')
      if (isLists) {
        arrJson.forEach(el => {
          classArr.push({
            id: el.id,
            name: el.name,
            lists: this.getList(el.lists, false)
          })
          console.log(el)
        });
        console.log(classArr)
      }
      else {
        arrJson.forEach(el => {
          classArr.push({
            id: el.id,
            name: el.name,
          })
        });
      }
      return classArr
    },
    //保存
    submit () {
      this.edTypevalues()
      this.$emit('careCheck', this.typeValse, this.newlist)
      this.show = false
    },
    edTypevalues () {
      console.log(this.typeValse)
      let datalist = []
      let data = {}
      if (this.typeValse.length < 6) {
        this.typeOption.forEach(c => {
          c.lists.forEach(v => {
            this.typeValse.forEach(x => {
              if (v.id === x) {
                data = {
                  Id: c.id,
                  Value: c.name,
                  Lists: [{
                    Id: v.id,
                    Value: v.name,
                  }],
                }
                datalist.push(data);
              }
            })
          })
        })
        let newList = []
        datalist.forEach(c => {
          console.log(c, 'cc')
          for (let i = 0; i < newList.length; i++) {
            if (newList[i].Id === c.Id) {
              newList[i].Lists = [...newList[i].Lists, ...c.Lists];
              return;
            }
          }
          newList.push({
            Id: c.Id,
            Value: c.Value,
            Lists: c.Lists,
          });
        })
        this.newlist = newList
      }
    }

  },
};
</script>

<style lang="scss" scoped>
.reg_care_pop {
  width: 80%;
  height: 100vh;
  background: #131825;
  color: #fff;
  .reg_care {
    padding: 0.24rem 0.24rem 0;
    &::v-deep .care_checkbox {
      display: block;
      .van-checkbox {
        margin: 0 0.16rem 0.16rem 0;
        padding: 0 0.18rem;
        line-height: 0.54rem;
        border: 1px solid #bfbfbf;
        border-radius: 3px;

        &[aria-checked="true"] {
          border-color: #f85b0f;
          background: #f85b0f;
        }
        .van-checkbox__icon {
          display: none;
        }
        .van-checkbox__label {
          color: #fff;
          margin-left: 0;
          line-height: 0.54rem;
        }
      }
      .van-collapse {
        &::after {
          display: none;
        }
        .care_item {
          .van-collapse-item__title {
            padding: 0;
            height: 0.65rem;
            background: transparent;
            &[aria-expanded="true"] {
              .van-cell__title::after {
                content: "收起";
              }
            }
            &::after {
              display: none;
            }
            .van-cell__title {
              line-height: 0.65rem;
              color: #bfbfbf;
              display: flex;
              justify-content: space-between;
              &::after {
                content: "展开";
                line-height: 0.65rem;
                color: #fff;
              }
              span {
                font-size: 0.26rem;
              }
            }
            .van-icon {
              line-height: 0.65rem;
              height: auto;
              font-size: 0.24rem;
              color: #bfbfbf;
              margin-left: 0.1rem;
            }
          }
          .van-collapse-item__content {
            background: transparent;
            padding: 0;
            line-height: 1;
            .checkbox_wrap {
              display: flex;
              flex-wrap: wrap;
            }
          }
        }
      }
    }
  }
  .sumbit_btn {
    font-size: 0.36rem;
    height: 0.98rem;
    line-height: 0.98rem;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    border-radius: 0;
    span {
      font-size: 0.36rem;
    }
  }
}
</style>
